import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { AppRouter } from './router';
import { Provider } from 'react-redux';
import {store } from './redux/store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRouter />
    </Provider>
  </React.StrictMode>
);
